(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name commons.directive:checkPrivilege
     * @restrict EA
     * @element
     *
     * @description
     * to check the privilege and hide the element.
     * @example
     <example module="commons">
        <input type='text' uppercased>
     </example>
     *
     */
    angular
        .module('commons')
        .directive('uppercased', uppercased);
    function uppercased() {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, modelCtrl) {
                modelCtrl.$parsers.push(function (input) {
                    return input ? input.toUpperCase() : "";
                });
                element.css("text-transform", "uppercase");
            }
        }
    }
}());